'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

var _AbstractField2 = require('./AbstractField');

var _AbstractField3 = _interopRequireDefault(_AbstractField2);

var _Utils = require('./../Utils2');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Field pro editaci kontaktu.
 */
var KontaktField = function (_AbstractField) {
    (0, _inherits3.default)(KontaktField, _AbstractField);

    function KontaktField() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, KontaktField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = KontaktField.__proto__ || (0, _getPrototypeOf2.default)(KontaktField)).call.apply(_ref, [this].concat(args))), _this), _this.getInputValue = function (value) {
            return value ? value.kontakt ? value.kontakt : "" : "";
        }, _this.getObjValue = function (e) {
            var _this$props = _this.props,
                value = _this$props.value,
                kontaktType = _this$props.kontaktType;


            var objValue = void 0;
            if (value) {
                objValue = (0, _extends3.default)({
                    typKontaktu: kontaktType }, value, {
                    kontakt: e.target.value,
                    "@class": "KontaktVO"
                });
            } else {
                objValue = {
                    typKontaktu: kontaktType,
                    vazbaZr: false,
                    kontakt: e.target.value,
                    "@class": "KontaktVO"
                };
            }

            return objValue;
        }, _this.handleChange = function (e) {
            var onChange = _this.props.onChange;

            onChange(_this.getObjValue(e));
        }, _this.handleBlur = function (e) {
            var onBlur = _this.props.onBlur;

            onBlur(_this.getObjValue(e));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(KontaktField, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                addonsBefore = _props.addonsBefore,
                addonsAfter = _props.addonsAfter,
                onChange = _props.onChange,
                onBlur = _props.onBlur,
                kontaktType = _props.kontaktType,
                value = _props.value,
                props = (0, _objectWithoutProperties3.default)(_props, ['addonsBefore', 'addonsAfter', 'onChange', 'onBlur', 'kontaktType', 'value']);


            var field = _react2.default.createElement(_reactstrap.Input, (0, _extends3.default)({
                type: 'text',
                onChange: this.handleChange,
                onBlur: this.handleBlur,
                value: this.getInputValue(value)
            }, props));

            return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
        }
    }]);
    return KontaktField;
}(_AbstractField3.default);

KontaktField.PropTypes = {
    // Typ kontaktu, konstanta z EnumTypKontakt
    kontaktType: _react2.default.PropTypes.string.isRequired,
    // Objekt typu KontaktRO
    value: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.object, _react2.default.PropTypes.string]), // string musí být, protože při prázdném poli dává redux prázdný string, místo objektu!
    addonsBefore: _Utils.COMPONENT_CHILDREN,
    addonsAfter: _Utils.COMPONENT_CHILDREN
};
exports.default = KontaktField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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